export interface SearchItem {
  id: string;
  type: 'vulnerability' | 'domain' | 'port' | 'asset' | 'finding' | 'data_leak' | 'credential_leak';
  title: string;
  description: string;
  link: string;
  tags: string[];
}

export const searchData: SearchItem[] = [
  {
    id: '1',
    type: 'vulnerability',
    title: 'Critical SQL Injection',
    description: 'SQL injection vulnerability found in login endpoint',
    link: '/findings/vuln-1',
    tags: ['critical', 'api', 'authentication']
  },
  {
    id: '2',
    type: 'domain',
    title: 'example.com',
    description: 'Primary domain with 23 subdomains',
    link: '/domains/example-com',
    tags: ['production', 'primary']
  },
  {
    id: '3',
    type: 'port',
    title: 'Open Port 22 (SSH)',
    description: 'SSH service running on production server',
    link: '/ports/port-22',
    tags: ['ssh', 'production']
  },
  {
    id: '4',
    type: 'asset',
    title: 'Production API Server',
    description: 'Main API server with 3 critical vulnerabilities',
    link: '/assets/api-1',
    tags: ['server', 'production', 'critical']
  },
  {
    id: '5',
    type: 'finding',
    title: 'Outdated SSL Certificate',
    description: 'SSL certificate expiring in 7 days',
    link: '/findings/ssl-1',
    tags: ['ssl', 'medium']
  },
  {
    id: '6',
    type: 'data_leak',
    title: 'Source Code Exposure',
    description: 'Internal source code found in public repository',
    link: '/data-leaks/leak-1',
    tags: ['source-code', 'github']
  },
  {
    id: '7',
    type: 'credential_leak',
    title: 'API Key Exposure',
    description: 'Production API key found in public repository',
    link: '/credential-leaks/cred-1',
    tags: ['api-key', 'critical']
  },
  {
    id: '8',
    type: 'vulnerability',
    title: 'Cross-Site Scripting (XSS)',
    description: 'Reflected XSS vulnerability in search function',
    link: '/findings/vuln-2',
    tags: ['high', 'web', 'xss']
  },
  {
    id: '9',
    type: 'domain',
    title: 'api.example.com',
    description: 'API subdomain with 2 high vulnerabilities',
    link: '/domains/api-example-com',
    tags: ['api', 'production']
  },
  {
    id: '10',
    type: 'port',
    title: 'Open Port 3306 (MySQL)',
    description: 'MySQL database port exposed to internet',
    link: '/ports/port-3306',
    tags: ['database', 'mysql', 'critical']
  }
];